window.addEventListener("load", function () {
  if (typeof AOS === "undefined") return;
  AOS.init({ once: true });
});
